import { Injectable } from '@angular/core';

import { BaseService } from 'ngx-elvis-ds';

import { SAMService } from './sam.service';
import { JHIMService } from '../jhim/jhim.service';
import { SAMMessage } from './interfaces/sam-message';
import { InfoDialogPage } from '../gui/gui-dialogs/info-dialog/info-dialog.page';
import { ModalOptions } from '@ionic/core';
import { ModalController, NavController } from '@ionic/angular';
import { ConfigService } from '../config.service';
import { GUIHelperService } from '../gui-helper.service';
import { GUIService } from '../gui/gui.service';
import { ActivatedRoute } from '@angular/router';
// import { GUIService } from '../gui/gui.service';
// import { JHIMService } from '../jhim/jhim.service';
// import { SAMDialogsService } from './sam-dialogs.service';

@Injectable({
  providedIn: 'root'
})
export class SAMSessionService extends BaseService {

  initialized = false;
  isSupervisor = false;
  isClosingSession = false;

  get isRunning() {
    return this.sam.status === 'online';
  }

  constructor(
    public sam: SAMService,
    public jhim: JHIMService,
    private modalCtrl: ModalController,
    private configSvc: ConfigService,
    private guiHelperSvc: GUIHelperService,
    private guiSvc: GUIService,
    private route: ActivatedRoute
    // public menu: MenuService,
    // public velocityCodes: VelocityCodesService,
    // public confirmDialog: ConfirmDialogService,
    // public infoDialog: InfoDialogService,
    // public inputDialog: InputDialogService,
    // public keyboard: KeyboardService,
    // public payment: PaymentService,
    // public searchDialog: SearchDialogService,
    // public searchDialogData: SearchDialogDataService,
  ) {
    super();
  }

  /**
   * Initialize a new Session and subscribe all listeners in other services
   *
   * @returns
   * @memberof SAMSessionService
   */
  async init() {
    // subscribe session listeners
    this.subscribeListeners();
    this.sam.subscribeListeners();
    this.jhim.subscribeListeners();

    // all services initialized
    this.sam.connect(this.configSvc.samAddress);
    this.events.complete();
    this.initialized = true;
    return true;
  }

  /**
   * End current session, reloading page is the safest method currently
   *
   * @memberof SAMSessionService
   */
  async end(showDialog: boolean = false, _timeout?: number) {
    if (this.isClosingSession) {
      return;
    }

    this.isClosingSession = true;
    this.guiHelperSvc.onLogout();

    // unsubscribe session listeners
    const modalOptions: ModalOptions = {
      component: InfoDialogPage,
      backdropDismiss: false,
      cssClass: 'confirm-dialog fullscreen',
      componentProps: {
        data: {
          Title: 'Errore di Connessione',
          Button: `Ricarica`,
          Info1: `La connessione con SAM si è chiusa inaspettatamente.`,
        },
        isLocal: true
      }
    };

    const modal = await this.modalCtrl.create(modalOptions);

    modal.onDidDismiss().then((resp) => {
      this.onReload()
    });

    if (showDialog) {
      await modal.present();
    }

    let reloadTimeout = this.configSvc.isLogged || this.configSvc.loginSent ? 1000 : 5000;

    if (_timeout) {
      reloadTimeout = _timeout;
    }

    setTimeout(() => {
      this.onReload()
    }, reloadTimeout);
  }

  requestSupervisor(requestReason: string = 'none') {
    this.sam.onSend({
      Command: (this.isSupervisor ? 'CMD_EXIT_SUPERVISOR_MODE' : 'CMD_ASK_SUPERVISOR_MODE'),
      parms: { reason: requestReason }
    });
  }

  // private

  private onReload() {
    if (this.configSvc.isLogged || this.configSvc.loginSent) {
      window.location.reload()
    } else {
      this.isClosingSession = false;
      this.guiSvc.status.online = false;
      this.configSvc.isLogged = false;
      this.sam.connect(this.configSvc.samAddress);
    }
  }

  /**
   * Subscribe to SAM Events
   *
   * @private
   * @memberof SAMSessionService
   */
  private subscribeListeners() {

    // Subscribe to SAM WebSocket Events
    this.sam.events.subscribe((status: string) => {
      if (status === 'close') { this.end(); }
    });

    // this.sam.channels.auth.subscribe('sam:SET_SUPERVISOR_MODE', (data: any) => {
    //   this.supervisorMode = data.Enable;
    // });

    // Subscribe to Auth Channel Events
    this.sam.channels.auth.subscribe((msg: SAMMessage) => {
      if (['LOGOFF'].includes(msg.Command)) { this.end(false); }
      if (['RELOAD_GUI'].includes(msg.Command)) { this.end(false); }
      if (['SET_SUPERVISOR_MODE'].includes(msg.Command)) { this.isSupervisor = msg.parms.Enable; }
    });
  }
}
